module.exports = __webpack_public_path__ + "img/sp.258bd73a.png";